(() => {
  
  var MODULE = {
    
    init: function () {
      this.registerVariantIds();
      this.registerVariables();
      this.registerEventHandlers();
    },

    registerVariantIds: function () {
      this.variantIds = [43037321330867]; // Array of Variant IDs
    },

    registerVariables: function () {
      this.confettiVariantFound = false;
      this.confettiAnimationRun = false;
    },

    registerEventHandlers: function () {
      document.addEventListener('giftship.drawer-cart.opened', this.handleCartEvents.bind(this));
      document.addEventListener('giftship.drawer-cart.upsell-clicked', this.handleCartEvents.bind(this));
    },

    handleCartEvents: function () {
      this.checkCartForVariantAndBundles();
    },

    checkCartForVariantAndBundles: function () {
      GIST.ajaxApi.getCart()
        .then((data) => {
          let variantFound = false;

          data.items.forEach((item, index) => {
            if (this.variantIds.includes(item.variant_id)) {
              variantFound = true;
            }

            if (item.properties && Array.isArray(item.properties._gs_bundle_ids) &&
                item.properties._gs_bundle_ids.some(id => this.variantIds.includes(Number(id)))) {
              variantFound = true;
            }

            if (variantFound) {
              //console.log(`variant = found in item ${index + 1}`);
              this.confettiVariantFound = true;
            } else {
              this.confettiVariantFound = false; // new
            }
          });

          if (variantFound) {
            this.considerAnimation();
          }
        })
        .catch((error) => {
          console.error("An error occurred while fetching cart data:", error);
        });
    },

    considerAnimation: function () {
      if (!this.confettiAnimationRun && this.confettiVariantFound) {
        this.runAnimation();
      }
    },

    runAnimation: function () {
     
      this.confettiAnimationRun = true;

      // tsparticles.confetti

      const count = 200,
        defaults = {
          origin: { y: 0.7 },
          zIndex: 99999 // important
        };

      function fire(particleRatio, opts) {
        confetti(
          Object.assign({}, defaults, opts, {
            particleCount: Math.floor(count * particleRatio),
          })
        );
      }

      fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });

      fire(0.2, {
        spread: 60,
      });

      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
      });

      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
      });

      fire(0.1, {
        spread: 120,
        startVelocity: 45,
      });

     // Set timeout to reset confettiAnimationRun to false after 1 minutes (60000 milliseconds)
      setTimeout(() => {
        this.confettiAnimationRun = false;
      }, 60000);
      
    },
  };

  MODULE.init();
})();